import gql from "graphql-tag";

export const MY_HR_DELETE_CHANGE_REQUEST = gql`
  mutation deleteChangeRequest($_id: String!, $locale: String!) {
    deleteChangeRequest(_id: $_id, locale: $locale)
  }
`;
